import React, { useState } from 'react';
import useDashboardData from '../../components/hooks/hooks-admin/useDashboardData'
import './homedashboard.scss';

function HomeDashboard() {
    const [showOrderDetail, setShowOrderDetail] = useState(false);
    const [selectedOrderForDetail, setSelectedOrderForDetail] = useState(null);

    // Utilizzo dell'hook per dati reali
    const {
        // Stato
        orders,
        loading,
        error,
        statsCards,
        chartData,
        //recentActivities: hookRecentActivities,
        
        // Azioni
        fetchOrderDetail,
        updateOrderStatus,
        formatCurrency,
        formatDate,
        isUpdatingOrder
    } = useDashboardData();

    // Costanti per i servizi admin (statici)
    const adminServices = [
        {
            id: 2,
            title: '👥 Gestione Utenti',
            description: 'Amministra gli account utenti, verifica email, attiva/disattiva profili.',
            icon: '👥',
            link: '/admin/users',
            color: '#2c3e50'
        },
        {
            id: 1,
            title: '📦 Gestione Ordini',
            description: 'Visualizza, modifica e aggiorna lo stato degli ordini. Gestisci spedizioni e tracking.',
            icon: '📦',
            link: '/admin/orders',
            color: '#8B0000'
        },
        {
            id: 3,
            title: '📈 Statistiche e Report',
            description: 'Visualizza report di vendita, analisi fatturato e metriche di performance.',
            icon: '📊',
            link: '/admin/stats',
            color: '#16a085'
        },
        {
            id: 4,
            title: '🏷️ Coupon e Sconti',
            description: 'Crea e gestisci codici sconto, promozioni e offerte speciali.',
            icon: '🏷️',
            link: '/admin/coupons',
            color: '#e67e22'
        },
        {
            id: 5,
            title: '🚚 Tracking Spedizioni',
            description: 'Gestisci i corrieri, aggiorna i tracking e notifica i clienti.',
            icon: '🚚',
            link: '/admin/shipping',
            color: '#3498db'
        },
        {
            id: 6,
            title: '📧 Newsletter',
            description: 'Invia comunicazioni email, gestisci iscritti e campagne marketing.',
            icon: '📧',
            link: '/admin/newsletter',
            color: '#9b59b6'
        },
        {
            id: 7,
            title: '🏭 Fornitore',
            description: 'Gestisci i fornitori, contatti, contratti e gestione acquisti.',
            icon: '🏭',
            link: '/admin/suppliers',
            color: '#278ceb'
        }
    ];

    // Funzione per gestire il click sul dettaglio ordine
    const handleViewOrderDetails = async (orderId) => {
        const order = await fetchOrderDetail(orderId);
        if (order) {
            setSelectedOrderForDetail(order);
            setShowOrderDetail(true);
        }
    };

    // Funzione per chiudere il modal
    const closeOrderDetail = () => {
        setShowOrderDetail(false);
        setSelectedOrderForDetail(null);
    };

     // Render loading
    if (loading.stats && loading.orders) {
        return (
            <div className="home-dashboard">
                <div className="loading-container">
                    <div className="spinner"></div>
                    <p>Caricamento dashboard...</p>
                </div>
            </div>
        );
    }

    // Render error
    if (error && !loading.stats) {
        return (
            <div className="home-dashboard">
                <div className="error-container">
                    <div className="error-icon">⚠️</div>
                    <h3>Errore nel caricamento</h3>
                    <p>{error}</p>
                    <button onClick={() => window.location.reload()} className="retry-btn">
                        Riprova
                    </button>
                </div>
            </div>
        );
    }


    return (
        <div className="home-dashboard">
            {/* Header della dashboard */}
            <div className="dashboard-header">
                <h2>🏠 Panoramica Amministrazione</h2>
                <p>Benvenuto nella tua area di gestione. Da qui puoi controllare e amministrare tutto il tuo e-commerce.</p>
            </div>

            {/* Cards statistiche con dati reali */}
            <div className="stats-grid">
                <div className="stat-card">
                    <div className="stat-icon">📦</div>
                    <div className="stat-value">{statsCards.totalOrders?.value || 0}</div>
                    <div className="stat-label">Totale Ordini</div>
                    {statsCards.totalOrders?.change && (
                        <div className={`stat-trend ${statsCards.totalOrders.change >= 0 ? 'positive' : 'negative'}`}>
                            {statsCards.totalOrders.change >= 0 ? '↑' : '↓'} {Math.abs(statsCards.totalOrders.change)}% rispetto al mese scorso
                        </div>
                    )}
                </div>
                
                <div className="stat-card">
                    <div className="stat-icon">👥</div>
                    <div className="stat-value">{statsCards.totalUsers?.value || 0}</div>
                    <div className="stat-label">Utenti Registrati</div>
                    <div className="stat-trend">+{statsCards.totalUsers?.newThisMonth || 0} nuovi questo mese</div>
                </div>
                
                <div className="stat-card">
                    <div className="stat-icon">💰</div>
                    <div className="stat-value">{statsCards.totalRevenue?.formatted || '€ 0'}</div>
                    <div className="stat-label">Fatturato Totale</div>
                    {statsCards.totalRevenue?.change && (
                        <div className={`stat-trend ${statsCards.totalRevenue.change >= 0 ? 'positive' : 'negative'}`}>
                            {statsCards.totalRevenue.change >= 0 ? '↑' : '↓'} {Math.abs(statsCards.totalRevenue.change)}% rispetto al mese scorso
                        </div>
                    )}
                </div>
                
                <div className="stat-card">
                    <div className="stat-icon">⏳</div>
                    <div className="stat-value">{statsCards.pendingOrders?.value || 0}</div>
                    <div className="stat-label">Ordini in Attesa</div>
                    <div className="stat-trend">Da processare</div>
                </div>
            </div>

            {/* Grafico trend vendite (opzionale) */}
            {chartData.trendChart && chartData.trendChart.length > 0 && (
                <div className="trend-section">
                    <h3>📈 Trend Vendite (Ultimi 7 giorni)</h3>
                    <div className="trend-chart">
                        {chartData.trendChart.map((day, index) => (
                            <div key={index} className="trend-bar">
                                <div className="bar-label">{day.date}</div>
                                <div className="bar-container">
                                    <div 
                                        className="bar-fill" 
                                        style={{ 
                                            height: `${(day.orders / Math.max(...chartData.trendChart.map(d => d.orders))) * 100}%`,
                                            backgroundColor: '#8B0000'
                                        }}
                                    >
                                        <span className="bar-value">{day.orders}</span>
                                    </div>
                                </div>
                                <div className="bar-amount">{formatCurrency(day.revenue)}</div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Sezione Servizi Admin */}
            <div className="services-section">
                <h3>🛠️ Servizi Amministratore</h3>
                <div className="services-grid">
                    {adminServices.map(service => (
                        <a href={service.link} key={service.id} className="service-card" style={{ borderTopColor: service.color }}>
                            <div className="service-icon" style={{ backgroundColor: service.color + '15', color: service.color }}>
                                {service.icon}
                            </div>
                            <h4>{service.title}</h4>
                            <p>{service.description}</p>
                            <span className="service-link">Accedi →</span>
                        </a>
                    ))}
                </div>
            </div>

            {/* Attività recenti e ordini recenti */}
            <div className="recent-section">
                <div className="recent-activities">
                    <h3>📋 Ordini Recenti</h3>
                    <div className="activities-list">
                        {loading.orders ? (
                            <div className="loading-activities">
                                <div className="spinner-small"></div>
                                <p>Caricamento ordini...</p>
                            </div>
                        ) : orders && orders.length > 0 ? (
                            orders.slice(0, 5).map(order => (
                                <div key={order.id} className={`activity-item status-${order.stato}`}>
                                    <div className="activity-icon">
                                        {order.stato === 'pending' && '⏳'}
                                        {order.stato === 'processing' && '⚙️'}
                                        {order.stato === 'shipped' && '🚚'}
                                        {order.stato === 'delivered' && '✅'}
                                        {order.stato === 'cancelled' && '❌'}
                                    </div>
                                    <div className="activity-content">
                                        <div className="activity-action">
                                            Ordine {order.numero_ordine}
                                            <span className="order-amount">{formatCurrency(order.totale)}</span>
                                        </div>
                                        <div className="activity-user">
                                            {order.cliente.nome} {order.cliente.cognome}
                                        </div>
                                        <div className="order-status-badge" data-status={order.stato}>
                                            {order.stato === 'pending' && 'In attesa'}
                                            {order.stato === 'processing' && 'In elaborazione'}
                                            {order.stato === 'shipped' && 'Spedito'}
                                            {order.stato === 'delivered' && 'Consegnato'}
                                            {order.stato === 'cancelled' && 'Annullato'}
                                        </div>
                                    </div>
                                    <div className="activity-time">{formatDate(order.data_creazione)}</div>
                                    <button 
                                        className="view-details-btn"
                                        onClick={() => handleViewOrderDetails(order.id)}
                                        disabled={isUpdatingOrder(order.id)}
                                    >
                                        Dettagli
                                    </button>
                                </div>
                            ))
                        ) : (
                            <div className="no-activities">
                                <p>Nessun ordine recente</p>
                            </div>
                        )}
                    </div>
                </div>

                <div className="quick-actions">
                    <h3>⚡ Azioni Rapide</h3>
                    <div className="quick-buttons">
                        <button className="quick-btn" onClick={() => window.location.href = '/admin/orders'}>
                            📦 Vedi Ordini
                        </button>
                        <button className="quick-btn" onClick={() => window.location.href = '/admin/users'}>
                            👥 Gestisci Utenti
                        </button>
                        <button className="quick-btn" onClick={() => window.location.href = '/admin/stats'}>
                            📊 Report
                        </button>
                        <button className="quick-btn" onClick={() => window.location.href = '/admin/coupons'}>
                            🏷️ Sconti
                        </button>
                        <button className="quick-btn" onClick={() => window.location.href = '/admin/shipping'}>
                            🚚 Tracking
                        </button>
                        <button className="quick-btn" onClick={() => window.location.href = '/admin/newsletter'}>
                            📧 Newsletter
                        </button>
                        <button className="quick-btn" onClick={() => window.location.href = '/admin/suppliers'}>
                            🏭 Fornitore
                        </button>
                    </div>
                </div>
            </div>

            {/* Modal Dettaglio Ordine */}
            {showOrderDetail && selectedOrderForDetail && (
                <div className="modal-overlay" onClick={closeOrderDetail}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3>Dettaglio Ordine #{selectedOrderForDetail.numero_ordine}</h3>
                            <button className="modal-close" onClick={closeOrderDetail}>×</button>
                        </div>
                        <div className="modal-body">
                            <div className="order-info">
                                <div className="info-group">
                                    <label>Cliente:</label>
                                    <p>{selectedOrderForDetail.cliente.nome} {selectedOrderForDetail.cliente.cognome}</p>
                                </div>
                                <div className="info-group">
                                    <label>Email:</label>
                                    <p>{selectedOrderForDetail.cliente.email}</p>
                                </div>
                                <div className="info-group">
                                    <label>Data:</label>
                                    <p>{formatDate(selectedOrderForDetail.data_creazione)}</p>
                                </div>
                                <div className="info-group">
                                    <label>Metodo Pagamento:</label>
                                    <p>{selectedOrderForDetail.metodo_pagamento}</p>
                                </div>
                                <div className="info-group">
                                    <label>Stato:</label>
                                    <select 
                                        value={selectedOrderForDetail.stato}
                                        onChange={(e) => {
                                            updateOrderStatus(selectedOrderForDetail.id, e.target.value);
                                            if (!isUpdatingOrder(selectedOrderForDetail.id)) {
                                                closeOrderDetail();
                                            }
                                        }}
                                        disabled={isUpdatingOrder(selectedOrderForDetail.id)}
                                        className="status-select"
                                    >
                                        <option value="pending">In attesa</option>
                                        <option value="processing">In elaborazione</option>
                                        <option value="shipped">Spedito</option>
                                        <option value="delivered">Consegnato</option>
                                        <option value="cancelled">Annullato</option>
                                    </select>
                                </div>
                            </div>
                            
                            <div className="items-list">
                                <h4>Prodotti</h4>
                                {selectedOrderForDetail.items?.map((item, index) => (
                                    <div key={index} className="order-item">
                                        {item.img && <img src={item.img} alt={item.nome} className="item-image" />}
                                        <div className="item-details">
                                            <div className="item-name">{item.nome}</div>
                                            <div className="item-quantity">Quantità: {item.quantita}</div>
                                        </div>
                                        <div className="item-price">{formatCurrency(item.prezzo_totale)}</div>
                                    </div>
                                ))}
                            </div>
                            
                            <div className="order-totals">
                                <div className="total-line">
                                    <span>Subtotale:</span>
                                    <span>{formatCurrency(selectedOrderForDetail.subtotale)}</span>
                                </div>
                                <div className="total-line">
                                    <span>Spedizione:</span>
                                    <span>{formatCurrency(selectedOrderForDetail.costo_spedizione)}</span>
                                </div>
                                <div className="total-line grand-total">
                                    <span>Totale:</span>
                                    <span>{formatCurrency(selectedOrderForDetail.totale)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
export default HomeDashboard;
